import React from "react";
import { UserOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import Table from "../../UiTable/UiTable";
import { ColumnFilter } from "../../UiTable/ColumnFilter";

import moment from "moment";
import useWindowSize from "./../../../utils/useWindowSize";
const AccessManagementService = (props) => {
  const {
    domainData,
    statusType,
    columnsData,
    hiddenColumns,
    columnOrder,
    handleToggleSort,
    handleRedirect,
    assignedToMe,
    onSearch,
    actionDataList,
    pageTotalCount,
    pageIndex,
    pageSize,
    pagination,
    setPagination,
    partnerRefresh,
    setPartnerRefresh,
    roleTypeList,
    selectedTab,
  } = props;

  const { width } = useWindowSize();
  const mobile = width < 786;

  const sequentialColumns = columnsData.sort((a, b) => a.sequence - b.sequence);
  const COLUMNS = sequentialColumns.map((columnInfo) => {
    return {
      id: columnInfo.fieldId,
      Header: columnInfo.fieldDisplayName,
      accessor: columnInfo.fieldName,
      sticky: columnInfo.isFixed ? "left" : "",
      width: columnInfo.fieldName === "age" ? (mobile ? 100 : 150) : 200,

      Cell: ({ value }) => {
        if (columnInfo.fieldDisplayName === "Age") {
          let time = parseInt(value?.slice(-3, -1) ?? 0);
          if (parseInt(value[0]) > 0) {
            time += 100;
          }

          return (
            <div
              style={{
                background:
                  time <= 6 ? "#7CC576" : time <= 24 ? "#FFC30D" : "red",
                color: "white",
                padding: "5px",
                textAlign: "right",
              }}
            >
              {value}
            </div>
          );
        }
        if (columnInfo.name === "Action")
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ paddingLeft: 10 }}>
                <UserOutlined style={{ cursor: "pointer" }} />
              </div>
              <div style={{ paddingLeft: 10 }}>
                <QuestionCircleOutlined style={{ cursor: "pointer" }} />
              </div>
            </div>
          );
        if (columnInfo.dataType === "DATE" && value !== null)
          return (
            <div style={{ display: "flex", justifyContent: "end" }}>
              {moment(new Date(value)).format("DD/MM/YYYY")}
            </div>
          );
        if (columnInfo.dataType === "NUMBER" && value !== null)
          return (
            <div style={{ display: "flex", justifyContent: "end" }}>
              {value}
            </div>
          );

        return value || null;
      },
      Filter: ({ column }) => {
        return (
          <ColumnFilter
            column={column}
            filter_type={columnInfo.dataType}
            fieldName={columnInfo?.fieldName}
            onSearch={onSearch}
            columnsDto={columnsData}
            roleTypeList={roleTypeList}
          />
        );
      },
      // width: "100%"
    };
  });

  React.useEffect(() => {
    let ageData = COLUMNS.find((ele) => ele.accessor === "age");
    if (ageData === undefined) {
      COLUMNS.push({
        id: 0,
        Header: "Age",
        accessor: "age",
        sticky: "left",
        width: 20,
        minWidth: 20,
        maxWidth: 20,
        canSort: true,
        // Cell: ({ row }) => <div className="ageBar">1h</div>
      });
    }
  }, [COLUMNS]);

  React.useEffect(() => {
    domainData.map((element, i) => {
      if (element.age === undefined) {
        element["age"] = i + "h";
      }
    });
    // setLisData(ageData);
  }, [domainData]);
  return (
    <div>
      <Table
        hiddenColumns={hiddenColumns}
        columnOrder={columnOrder}
        COLUMNS={COLUMNS}
        statusType={statusType}
        DATA={domainData}
        selectable={false}
        // setSelectedRows={e => console.log(e)}
        handleToggleSort={handleToggleSort}
        onRowClick={handleRedirect}
        assignToMeClick={assignedToMe}
        showExpanded={false}
        actionsColumn={true}
        ageColumn={true}
        actionDataList={actionDataList}
        pageTotalCount={pageTotalCount}
        pageIndexService={pageIndex}
        pageSizeService={pageSize}
        setPagination={setPagination}
        paginationService={pagination}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        selectedTab={selectedTab}
      />
    </div>
  );
};

export default AccessManagementService;
